import React from 'react'
import { Table } from 'semantic-ui-react'
import { IClockingAction } from '@cbgms/api/modules/clocking-actions'
import { IBaseClockingItem } from '@cbgms/api/modules/clocking-items'
import { Alert } from '@carsys/ui'
import { useTranslation } from 'react-i18next'
import TimeActionDetails from './TimeActionDetails'
import WorkorderClockingRow from './WorkorderClockingRow'
import { Typography } from '@mui/material'
import moment from 'moment'
import { useFeature } from '@cbgms/base/feature-flags'

interface ITimeActionsProps {
  clockIn: (typeUUID: string, workorderClockingItemUUID?: string) => void
  clockOut: () => void
  currentAction: IClockingAction | null
  items: IBaseClockingItem[]
  workorderClockingItems?: IBaseClockingItem[]
  NameComponent?: React.FC<{ name: string; url?: string; brand?: string }>
  id: string
  viewingWorkorder?: string
}

const TimeActions: React.FC<ITimeActionsProps> = ({
  clockIn,
  clockOut,
  currentAction,
  items,
  workorderClockingItems,
  NameComponent,
  id,
  viewingWorkorder
}) => {
  const { t } = useTranslation()

  const hasAllOrdersinTimeRegistration = useFeature('orders-in-time-registration')

  const appointmentDates =
    id === 'workorders' ? (items.length > 0 ? Array.from(new Set(items.map(workorder => workorder.AppointmentDate))) : []) : []
  return (
    <>
      {items.length === 0 && id === 'workorders' && (
        <Alert color='muted'>
          {viewingWorkorder === 'today'
            ? t('TimeRegistration.NoWorkorders')
            : viewingWorkorder === 'past'
            ? t('TimeRegistration.NoPastWorkorders')
            : t('TimRegistration.NoNextWorkorders')}
        </Alert>
      )}
      {items.length === 0 && id === 'items' && <Alert color='muted'>{t('TimeRegistration.NoClockingActions')}</Alert>}

      <Table data-testid={`timeregistration-actions-${id}`} basic='very' compact>
        <Table.Body>
          {id === 'items'
            ? items.map(action => (
                <TimeActionDetails
                  clockIn={clockIn}
                  clockOut={clockOut}
                  currentAction={currentAction}
                  id={id}
                  NameComponent={NameComponent}
                  item={action}
                  key={`time-action-${id}-${action.UUID}`}
                />
              ))
            : appointmentDates.map(appointment => {
                return (
                  <React.Fragment key={`appointment-${appointment}`}>
                    {hasAllOrdersinTimeRegistration && (
                      <Typography variant='body1' fontWeight='bold' marginTop={1.5} marginBottom={0.625}>
                        {moment(appointment).format('DD-MMM-YYYY')}
                      </Typography>
                    )}
                    {items
                      .filter(workorder => workorder.AppointmentDate === appointment)
                      .map(action => (
                        <WorkorderClockingRow
                          clockIn={clockIn}
                          clockOut={clockOut}
                          currentAction={currentAction}
                          NameComponent={NameComponent}
                          workorder={action}
                          workorderClockingItems={workorderClockingItems ?? []}
                          key={`time-action-${id}-${action.UUID}`}
                        />
                      ))}
                  </React.Fragment>
                )
              })}
        </Table.Body>
      </Table>
    </>
  )
}

export default TimeActions
